module.exports = __webpack_public_path__ + "static/media/tyrah-odoms.a447db0c.md";